module.exports = __webpack_public_path__ + "static/media/asthma-control-test-results.4b3762b2.svg";